import ApiService from '@/services/api.service';
import getters from '@/store/global';
import store from '@/store';

const state = {
    user: {},
    errors: {},
    register: false,
    resetType: 1,
    resetPhone: '',
    registerData: {}
};

getters['fetchUser'] = function(state) { return state.user }
getters['fetchRegister'] = function(state) { return state.register }
getters['fetchUserErrors'] = function(state) { return state.errors }
getters['fetchResetType'] = function(state) { return state.resetType }
getters['fetchResetPhone'] = function(state) { return state.resetPhone }
getters['fetchRegisterData'] = function(state) { return state.registerData }

const actions = {
    create(context, payload) {
        return ApiService
            .post('register/', payload)
            .then((response) => {
                context.commit('SET_REGISTER_DATA', response.data);
                context.commit('SET_ERROR', {});
            })
            .catch((response) => {
                if(response.status === 400){
                    context.commit('SET_ERROR', response.data);
                }
                throw new Error('Something goes wrong');
            });
    },
    saveProfile(context, [payload, partial = false]) {
        partial = partial || false;
        const method = partial ? 'patch' : 'put';
        return ApiService[method]('save/', payload)
            .then((response) => {
                context.commit('SET_USER', response.data);
                context.commit('SET_ERROR', {});
            })
            .catch((response) => {
                if(response.status === 400){
                    context.commit('SET_ERROR', response.data);
                }
                throw new Error('Something goes wrong');
            });
    },
    login(context, payload) {
        return ApiService
            .post('login/', payload)
            .then((response) => {
                context.commit('SET_ERROR', {});
                context.commit('SET_USER', response.data);
            })
            .catch((response) => {
                if(response.status === 400){
                    context.commit('SET_ERROR', response.data);
                }
                throw new Error('Something goes wrong');
            });
    },
    get(context, payload=false) {
        return ApiService
            .get('login/', payload)
            .then((response) => {
                context.commit('SET_ERROR', {});
                context.commit('SET_USER', response.data);
            })
            .catch(() => {
                throw new Error('Something goes wrong');
            });
    },
    logout(context) {
        return ApiService
            .get('logout/')
            .then(() => {
                context.commit('SET_ERROR', {});
                context.commit('SET_USER', {});
            })
            .catch(() => {
                throw new Error('Something goes wrong');
            });
    },
    activatePhone(context, payload) {
        return ApiService
            .get('activate-phone/' + payload.phone + '/' + payload.code + '/')
            .then((response) => {
                context.commit('SET_USER', response.data);
                context.commit('SET_ERROR', {});
            })
            .catch(() => {
                throw new Error('Something goes wrong');
            });
    },
    changePhone(context, payload) {
        return ApiService
            .get('change-phone/confirm/' + payload + '/')
            .then((response) => {
                context.commit('SET_PHONE', response.data.phone);
                context.commit('SET_ERROR', {});
            })
            .catch(() => {
                throw new Error('Something goes wrong');
            });
    },
    resetPassword(context, payload) {
        return ApiService
            .post('reset-password/', payload)
            .then((response) => {
                context.commit('SET_RESET_TYPE', response.data);
                context.commit('SET_ERROR', {});
            })
            .catch((response) => {
                if(response.status === 400){
                    context.commit('SET_ERROR', response.data);
                }
                throw new Error('Something goes wrong');
            });
    },
    resetPasswordConfirm(context, payload) {
        let url = payload.phone ?
            'reset-password-phone/confirm/' :
            'reset-password/confirm/';
        return ApiService
            .post(url, payload.data)
            .then((response) => {
                context.commit('SET_USER', response.data);
                context.commit('SET_ERROR', {});
            })
            .catch((response) => {
                if(response.status === 400){
                    context.commit('SET_ERROR', response.data);
                }
                throw new Error('Something goes wrong');
            });
    },
    setPersonal(context, payload) {
        return ApiService
            .put('profile/edit/personal/', payload)
            .then((response) => {
                context.commit('SET_ERROR', {});
            })
            .catch((response) => {
                context.commit('SET_ERROR', response.data);
                throw new Error('Something goes wrong');
            });
    },    
    vip(context, payload) {
        return ApiService
            .put('/profile/vip/', payload)
            .then((response) => {
                context.commit('SET_ERROR', {});
                context.commit('SET_USER', response.data);
                context.commit('SET_PROFILE_VIP', true);
            })
            .catch(() => {
                context.commit('SET_ERROR', response.data);
                throw new Error('Something goes wrong');
            });
    },
    setBalance(context, payload) {
        context.commit('SET_BALANCE', payload);
    },
    setAccountBalance(context, payload) {
        context.commit('SET_ACCOUNT_BALANCE', payload);
    },
    setWithdrawalDate(context, payload) {
        context.commit('SET_WITHDRAWAL_DATE', payload);
    },
    setEmpty(context) {
        context.commit('SET_USER', {});
    },
    setAvatar(context, payload) {
        return ApiService
            .patch('save/', payload)
            .then((response) => {
                context.commit('SET_ERROR', {});
                context.commit('SET_USER', response.data);
                context.commit('SET_PROFILE_AVATAR', response.data.avatar);
            })
            .catch((response) => {
                context.commit('SET_ERROR', response.data);
                throw new Error('Something goes wrong');
            });
    },
    setRegister(context, payload) {
        context.commit('SET_REGISTER', payload);
    },
    setResetPhone(context, payload) {
        context.commit('SET_RESET_PHONE', payload);
    }
};

const mutations = {
    SET_USER(state, user) {
        state.user = user;
    },
    SET_ERROR(state, errors) {
        state.errors = errors;
    },
    SET_PHONE(state, phone) {
        state.user.phone = phone;
    },
    SET_BALANCE(state, balance) {
        state.user.balance = balance;
    },
    SET_ACCOUNT_BALANCE(state, balance) {
        state.user.account_balance = balance;
    },
    SET_WITHDRAWAL_DATE(state, date) {
        state.user.withdrawal_date = date;
    },
    SET_PROFILE_AVATAR(state, avatar) {
        store.dispatch('profile/updateAvatar', avatar);
    },
    SET_PROFILE_VIP(state, vip) {
        store.dispatch('profile/updateVip', vip);
    },
    SET_REGISTER(state, register) {
        state.register = register;
    },
    SET_RESET_TYPE(state, resetType) {
        state.resetType = resetType;
    },
    SET_RESET_PHONE(state, resetPhone) {
        state.resetPhone = resetPhone;
    },
    SET_REGISTER_DATA(state, registerData) {
        state.registerData = registerData;
    }
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
